import React, { useState } from 'react';
import Helmet from 'react-helmet';
import { connect } from 'react-redux';

import TextButton from 'components/Button/TextButton';

import { Creators as FormCreators } from 'store/ducks/serviceForm';

import plusIcon from 'assets/img/plus-icon.svg';
import dolarIcon from 'assets/img/icons/dolar.svg';
import invoiceIcon from 'assets/img/icons/invoice.svg';

import { gaSendEvent } from '../../utils/analytics';

import OpenTasksList from './OpenTasksList';
import Dashs from './Dashs';
import ModalsList from './ModalsList';

import { Container, Header, SectionStyled } from './styles';

const Dashboards = ({ _openForm, _finishForm, loadingVisible }) => {
  const [paymentTicket, setPaymentTicket] = useState(false);
  const [invoice, setInvoice] = useState(false);

  const handleLocal = () => {
    gaSendEvent('novo_pedido', 'painel');
    _openForm({
      isOpen: true,
      isFormAddress: false,
      address: null,
      onFinish: _finishForm,
      selectedAddress: null,
    });
  };

  const handleInvoice = () => {
    gaSendEvent('ver_notas', 'painel');
    setInvoice(!invoice);
  };

  const handlePaymentTicket = () => {
    gaSendEvent('ver_boletos', 'painel');
    setPaymentTicket(!paymentTicket);
  };

  const makeIcon = (icon, handle, name) => (
    <TextButton btnIcon={icon} noShadow btnWidth="180px" onClick={handle}>
      {name}
    </TextButton>
  );

  return (
    <SectionStyled color="#FBFBFB">
      <Helmet title="Triider - Painel" />
      <Header>
        {makeIcon(plusIcon, handleLocal, 'Novo pedido')}
        {makeIcon(invoiceIcon, handleInvoice, 'Ver Notas Fiscais')}
        {makeIcon(dolarIcon, handlePaymentTicket, 'Ver Boletos')}
      </Header>
      <Container>
        <Dashs isLoading={loadingVisible} />
        <ModalsList
          paymentTicket={paymentTicket}
          setPaymentTicket={setPaymentTicket}
          invoice={invoice}
          setInvoice={setInvoice}
        />
        <OpenTasksList isLoading={loadingVisible} />
      </Container>
    </SectionStyled>
  );
};

const mapStateToProps = state => ({
  loadingVisible: state.ui.loaders.includes('DASH'),
});

const mapDispatchToProps = {
  _openForm: FormCreators.openForm,
  _finishForm: FormCreators.finishFormRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(Dashboards);
